import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navLinks = [{
    label: 'Product',
    path: '/product'
  }, {
    label: 'Security',
    path: '/security'
  }, {
    label: 'Use Cases',
    path: '/use-cases'
  }, {
    label: 'Docs',
    path: '/docs'
  }, {
    label: 'About',
    path: '/about'
  }];
  const isActive = (path: string) => {
    if (path === '/use-cases' && location.pathname.startsWith('/use-cases')) {
      return true;
    }
    return location.pathname === path;
  };
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <header className="sticky top-0 z-50 bg-[#0f1c2e] border-b border-white/10 shadow-lg" data-id="element-79">
      <div className="max-w-7xl mx-auto" data-id="element-80">
        <div className="flex items-center justify-between px-4 py-4 md:py-5" data-id="element-81">
          <div className="flex items-center gap-8" data-id="element-82">
            {/* Logo + Product Name */}
            <Link to="/" className="flex items-center hover:opacity-80 transition-opacity" onClick={closeMenu} data-id="element-83">
              <div className="flex items-center gap-2.5" data-id="element-84">
                <div className="h-8 w-8 bg-[#1e3a5f] rounded-lg flex items-center justify-center" data-id="element-85">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#4db8a4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5" data-id="element-86">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-87" />
                  </svg>
                </div>
                <span className="text-lg font-bold text-white tracking-tight" data-id="element-88">
                  Provenance<span className="text-[#4db8a4]" data-id="element-89">One</span>
                  <span className="text-gray-400 font-normal mx-1" data-id="element-90">:</span>
                  <span className="font-bold" data-id="element-91">MCPGuard</span>
                </span>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center gap-6" data-id="element-92">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`text-sm font-medium transition-colors hover:text-[#4db8a4] ${isActive(link.path) ? 'text-[#4db8a4]' : 'text-gray-300'}`} data-id="element-93">
                  {link.label}
                </Link>)}
            </nav>
          </div>

          {/* Desktop CTAs */}
          <div className="hidden md:flex items-center gap-4" data-id="element-94">
            <a href="https://console.provenanceone.ai/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-9 px-4 rounded-md text-sm font-medium bg-[#4db8a4] text-white hover:bg-[#3a9e8c] transition-colors shadow-sm" data-id="element-95">
              Console
            </a>
            <Link to="/early-access" className="text-sm font-medium text-gray-300 hover:text-[#4db8a4] transition-colors" data-id="element-96">
              Request Access &rarr;
            </Link>
          </div>

          {/* Mobile Menu Toggle */}
          <div className="md:hidden flex items-center gap-4" data-id="element-97">
            <a href="https://console.provenanceone.ai/" target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-[#4db8a4]" data-id="element-98">
              Console
            </a>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="p-2 -mr-2 text-gray-300 hover:text-white focus:outline-none" aria-label="Toggle menu" data-id="element-99">
              {isMobileMenuOpen ? <XIcon className="h-6 w-6" data-id="element-100" /> : <MenuIcon className="h-6 w-6" data-id="element-101" />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && <div className="md:hidden border-t border-white/10 bg-[#0f1c2e] animate-in slide-in-from-top-2 duration-200" data-id="element-102">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-103">
              {navLinks.map(link => <Link key={link.path} to={link.path} onClick={closeMenu} className={`block px-3 py-3 rounded-md text-base font-medium ${isActive(link.path) ? 'bg-[#4db8a4]/15 text-[#4db8a4]' : 'text-gray-300 hover:bg-white/5 hover:text-white'}`} data-id="element-104">
                  {link.label}
                </Link>)}
              <div className="mt-4 pt-4 border-t border-white/10" data-id="element-105">
                <Link to="/early-access" onClick={closeMenu} className="block w-full text-center px-4 py-3 rounded-md text-base font-medium bg-[#4db8a4] text-white hover:bg-[#3a9e8c]" data-id="element-106">
                  Request Access
                </Link>
              </div>
            </div>
          </div>}
      </div>
    </header>;
}